import React from 'react';
import Button from '@/components/ui/Button';
import { Calendar, MapPin, Building2, DollarSign, Clock, Eye, Filter, Search, X, ChevronDown, TrendingUp, Briefcase, CheckCircle, Send } from 'lucide-react';

const DetailsModal = ({ 
setShowDetailsModal,
selectedApplication,
getStatusConfig
}) => {


return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-sm">
<div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
<div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between">
<h2 className="text-lg font-bold text-gray-900">Application Details</h2>
<button
onClick={() => setShowDetailsModal(false)}
className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
>
<X className="w-6 h-6" />
</button>
</div>

<div className="p-6 space-y-6">
{/* Header */}
<div className="flex items-center justify-between">

<div className="flex items-center gap-4">
<img
src={selectedApplication.companyLogo}
alt={selectedApplication.company}
className="w-20 h-20 rounded-lg object-cover"
/>
<div>
<h3 className="text-xl font-semibold text-gray-900">{selectedApplication.jobTitle}</h3>
<p className="text-gray-600 text-sm">{selectedApplication.company}</p>
</div>
</div>


<div>
<div className={`flex items-center text-sm gap-2 px-3 py-1 rounded-full ${getStatusConfig(selectedApplication.status).color}`}>
{React.createElement(getStatusConfig(selectedApplication.status).icon, { className: "w-4 h-4" })}
<span className={` capitalize font-medium `}>
{getStatusConfig(selectedApplication.status).label}
</span>
</div>
</div>

</div>

{/* Job Info Grid */}
<div className="grid grid-cols-2 gap-4">
<div>
<p className="text-sm text-gray-600 mb-1">Applied Date</p>
<p className="font-medium text-gray-900">
{new Date(selectedApplication.appliedDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
</p>
</div> 
<div>
<p className="text-sm text-gray-600 mb-1">Application Deadline</p>
<p className="font-medium text-gray-900">
{new Date(selectedApplication.deadline).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Application Method</p>
<p className="font-medium text-gray-900">{selectedApplication.applicationMethod}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Location</p>
<p className="font-medium text-gray-900">{selectedApplication.location}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Salary Range</p>
<p className="font-medium text-gray-900">{selectedApplication.salary}</p>
</div>
<div>
<p className="text-sm text-gray-600 mb-1">Job Type</p>
<p className="font-medium text-gray-900">{selectedApplication.jobType}</p>
</div>


</div>


{/* Skills */}
<div>
<h4 className="font-semibold text-gray-900 mb-2">Submitted Documents</h4>
<div className="flex flex-wrap gap-2">
{selectedApplication.documents.map((doc, index) => (
<span key={index} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
{doc}
</span>
))}
</div>
</div>



</div>
</div>
</div>
);
};

export default DetailsModal;